import {GuestType} from 'types/Hotel'

import {roomsToConfigurationObject} from '@vio/core/src/room/business/roomConfiguration'

import {calculateGuestTypePercentages} from '../components/Accommodation/ReviewsSection/utils'

export const MERIT_BADGES = ['top_booked'] as const
export type MeritBadge = (typeof MERIT_BADGES)[number]
export type HotelBadge = MeritBadge | keyof GuestType

export const isMeritBadge = (badge: string): badge is MeritBadge =>
  (MERIT_BADGES as readonly string[]).includes(badge)

export const getTripType = (
  guestType: GuestType | undefined,
  rooms: string
): keyof GuestType | null => {
  if (!guestType) return null
  const {numberOfAdults: adults, numberOfChildren: children} =
    roomsToConfigurationObject(rooms)

  const {business, couples, families, groups, solo} = Object.fromEntries(
    calculateGuestTypePercentages(guestType).map(({key, value}) => [key, value])
  ) as Record<keyof GuestType, number>

  // Prefer the eligible badge whose share meets the threshold and whose search
  // rooms fit: 1 adult -> solo/business, 2 adults -> couples/business,
  // >2 adults or any children -> families/groups.
  if (adults === 1 && children === 0 && solo >= 30) return 'solo'
  if (adults === 2 && children === 0 && couples >= 35) return 'couples'
  if (adults <= 2 && children === 0 && business >= 30) return 'business'
  if ((adults > 2 || children >= 1) && families >= 35) return 'families'
  if (adults > 2 && groups >= 30) return 'groups'

  return null
}
